import type {Location} from 'history'

import {browserHistory} from '../routes'

import {trackCustomEvent} from './tracking'
import {generateFUSEvent, getEntity, getSecuredEntity} from './utils'

const trackRouting = (locationEntry: Location) => {
  const entity = getEntity(locationEntry)

  if (!entity) {
    return
  }

  const event = generateFUSEvent(
    'NAVIGATION',
    {...getSecuredEntity(entity)},
    {
      withContext: false,
      withReferrer: false,
    },
  )
  trackCustomEvent([event])
}

export const startRouterListening = () => {
  trackRouting(browserHistory.location)
  browserHistory.listen(historyEntry => {
    if (!historyEntry) {
      return
    }

    historyEntry.action === 'PUSH' && trackRouting(historyEntry.location)
  })
}
